import { render, staticRenderFns } from "./Colocation.vue?vue&type=template&id=287c7b12&"
import script from "./Colocation.vue?vue&type=script&lang=js&"
export * from "./Colocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports